<ng-template #deleteFileModal>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'components.files.delete-file-modal.title' | translate }}</h4>
    </div>

    <div class="modal-body">
        <p>
            {{ 'components.files.delete-file-modal.info' | translate }}
        </p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="hideDeleteFileModal(ConfirmModalResultEnum.Cancel)">
            <i class="icon element-cancel"></i>{{ 'components.files.delete-file-modal.cancel' | translate }}
        </button>

        <button type="button" class="btn btn-danger" (click)="hideDeleteFileModal(ConfirmModalResultEnum.Confirm)">
            <i class="icon element-delete"></i>{{ 'components.files.delete-file-modal.confirm' | translate }}
        </button>
    </div>
</ng-template>
